<template>
	<h1>Académies</h1>
	<table>
		<tr>
			<th></th>
			<th>Name</th>
			<th>Modifier</th>
			<th>Supprimer</th>
		</tr>
		<tr
			v-for="(academy, index) in this.$store.state.academies"
			:key="index"
		>
			<td>{{ index + 1 }}</td>
			<td>{{ academy.name }}</td>
			<td>
				<router-link
					:to="{
						name: 'SuperAdminEditAcademy',
						params: { id: academy.id },
					}"
					>Modifier</router-link
				>
			</td>
			<td>
				<button @click="deleteAcademy(academy.id)">
					supprimer
				</button>
			</td>
		</tr>
	</table>
</template>

<script>

export default {
	data() {
		return {
			academies: [],
		}
	},
	methods: {
		deleteAcademy(e) {
			this.$store.dispatch('deleteAcademy', e)
		},
	},
}
</script>

<style>
</style>
